const features = [
  { icon: 'ri-flashlight-line', title: 'Lightning Fast', desc: '15-30 minute withdrawals with instant deposits via local e-wallets and bank transfers.' },
  { icon: 'ri-shield-check-line', title: 'Bank-Grade Security', desc: '256-bit SSL encryption, strict KYC policy, and international gaming license for complete safety.' },
  { icon: 'ri-customer-service-2-line', title: '24/7 Local Support', desc: 'Dedicated support in English with under 60-second response times.' },
  { icon: 'ri-smartphone-line', title: 'Mobile Optimized', desc: 'Native Android APK and iOS browser experience with biometric login and push notifications.' },
  { icon: 'ri-coins-line', title: 'AUD Currency', desc: 'Full AUD support with local payment methods — PayID, Osko, POLi, Bank Transfer, and USDT.' },
  { icon: 'ri-vip-diamond-line', title: 'VIP Rewards', desc: '5-tier VIP club with personalized managers, luxury trips, and rebates up to 5%.' },
];

const stats = [
  { icon: 'ri-user-line', value: '1', suffix: 'M+', label: 'Active Players' },
  { icon: 'ri-gamepad-line', value: '5000', suffix: '+', label: 'Casino Games' },
  { icon: 'ri-time-line', value: '15', suffix: ' min', label: 'Avg Withdrawal' },
  { icon: 'ri-wifi-line', value: '99', suffix: '%', label: 'Uptime Guarantee' },
];

export default function FeaturesSection() {
  return (
    <>
      <section className="relative section-blue py-16 md:py-20 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-400/10 blur-[100px] rounded-full"></div>
        <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-blue-300/10 blur-[80px] rounded-full"></div>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-12">
            <span className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-4">
              <span className="w-2 h-2 rounded-full bg-blue-300 animate-pulse"></span>
              <span className="text-blue-200 text-xs font-semibold tracking-wider uppercase">Why Choose IPAY9</span>
            </span>
            <h2 className="section-title text-3xl md:text-4xl font-black text-white mb-4">Built for Australian Players</h2>
            <p className="text-blue-200/70 text-sm md:text-base max-w-2xl mx-auto">
              Every feature designed with local players in mind — from AUD currency support to Australia-specific payment methods and cultural game themes.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {features.map((f) => (
              <div key={f.title} className="glass-card-blue rounded-xl p-6 group transition-all duration-300 hover:scale-[1.02]">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 text-white mb-4 group-hover:shadow-lg group-hover:shadow-blue-500/30 transition-all duration-300">
                  <i className={`${f.icon} text-xl`}></i>
                </div>
                <h3 className="text-slate-800 font-bold text-base mb-2">{f.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative section-light-blue py-14 md:py-16 overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-blue-400/10 blur-[100px] rounded-full"></div>
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 lg:gap-12">
            {stats.map((s) => (
              <div key={s.label} className="text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 text-white mx-auto mb-4 shadow-lg shadow-blue-500/20">
                  <i className={`${s.icon} text-xl`}></i>
                </div>
                <div className="text-3xl sm:text-4xl md:text-4xl lg:text-5xl font-black text-slate-800">
                  {s.value}<span className="text-blue-500">{s.suffix}</span>
                </div>
                <div className="text-slate-600 text-sm font-medium mt-2">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
